import React from 'react';

import { onboardColors } from '../../theme/onboardTokens';
import { font, palette } from '../styles';

import type { TItemStatus } from '../types';

interface Props {
  status: TItemStatus;
  pendingLabel?: string;
}

const DOT_BY_STATUS: Record<TItemStatus, string> = {
  submitted: palette.green,
  locked: palette.inputBorder,
  pending: onboardColors.accent.tan
};

const LABEL_BY_STATUS: Record<TItemStatus, string> = {
  submitted: 'Completed',
  locked: 'Locked',
  pending: 'In Progress'
};

const StatusPill: React.FC<Props> = ({ status, pendingLabel = 'In Progress' }) => (
  <span
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 8,
      padding: '8px 32px 8px 8px',
      background: onboardColors.surface.white,
      border: `1px solid ${palette.divider}`,
      borderRadius: 6,
      fontFamily: font,
      fontSize: 12,
      color: palette.black
    }}
  >
    <span style={{ width: 6, height: 6, borderRadius: '50%', background: DOT_BY_STATUS[status] }} />
    {status === 'pending' ? pendingLabel : LABEL_BY_STATUS[status]}
  </span>
);

export default StatusPill;
